import { defineMessages } from '../../i18n/messages';

export const DemoVideoMessages = defineMessages({
  TITLE: {
    id: 'homepage.demo_video.title',
    text: 'See It in Action (90 Seconds)',
    description: 'Heading above the demo video on the homepage. Invites visitors to watch a short demo. Keep it concise and action-oriented.',
  },
  PLAY_ARIA: {
    id: 'homepage.demo_video.play_aria',
    text: 'Play the Localingos demo video',
    description: 'Screen reader label for the video play button.',
  },
});
